import { call, put } from "redux-saga/effects";

import { api, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginatePanelActions } from "store/ducks/transports";

export function* paginatePanelRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call( api.get, `/transports/list?${queryString}`);

    const { transports, pagination } = responseBody;
    yield put(PaginatePanelActions.success(transports, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginatePanelActions.failure(errorMessage));
  }
}
